import { useTranslation } from 'react-i18next'

import { RadioButtonOptionCard, Text } from '@reveni-io/reveni-ui'

import { visibilityOptions } from '../constants'
import * as Styles from './styles'

const ViewVisibilityOptions = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Visibilidad')}</Text>
      <Styles.Options>
        {visibilityOptions.map(option => (
          <RadioButtonOptionCard
            key={option.value}
            icon={<option.Icon size={24} />}
            title={t(option.label)}
            description={t(option.description)}
            name="view-visibility"
            value={option.value}
            selected={value === option.value}
            onChange={onChange}
          />
        ))}
      </Styles.Options>
    </Styles.Container>
  )
}

export default ViewVisibilityOptions
